exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button--light{background-color:#fff;background-image:-webkit-linear-gradient(350deg,#d4edfc,#d4edfc 50%,#f5f5f5 0,#f5f5f5);background-image:-o-linear-gradient(350deg,#d4edfc,#d4edfc 50%,#f5f5f5 0,#f5f5f5);background-image:linear-gradient(100deg,#d4edfc,#d4edfc 50%,#f5f5f5 0,#f5f5f5);color:#1464a5}.button--light:hover{color:#1973b8}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"minimize":true,"sourceMap":false}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null]}!./src/css/basics/Button.css
// module id = 428
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13